import {
  adminClient,
  lastLoginMethodClient,
  magicLinkClient,
} from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

export const authClient = createAuthClient({
  baseURL: window.origin,
  basePath: "/api/admin/auth",
  plugins: [lastLoginMethodClient(), magicLinkClient(), adminClient()],
})

export const { useSession, signIn, signOut } = authClient
